import React from 'react';

// Components
import { Button } from '@capintel/component-lib/button';
import { SecondaryLink } from '../../../../components/buttons';

// Utils
import { formatMessage, FormattedHTMLMessage } from '../../../../../utils/i18n';
import notification from '../../../../../utils/notification';

// Images
import { ReactComponent as BlueCheckmark } from '../../../../../images/blue-checkmark.svg?react';
import { ReactComponent as CopyIcon } from '../../../../../images/icons/copy-icon.svg?react';
import { Input } from '../../../../components/inputs';
import classNames from 'classnames';

type Props = {
  backup: string;
  variant?: 'Default' | 'BackupLogin' | 'NewBackup';
  primaryAction: () => void;
};

const copyToClipboard = async (code: string) => {
  await navigator.clipboard.writeText(code);
  notification.success(
    formatMessage('TwoFactorAuthentication.Notifications.CopiedToClipboard.Description'),
    formatMessage('TwoFactorAuthentication.Notifications.CopiedToClipboard.Title'),
  );
};

const EndStep = ({ backup, variant = 'Default', primaryAction }: Props) => (
  <div className={classNames('two-factor-step-content', 'two-factor-end-step', `variant-${variant}`)}>
    {variant === 'Default' && (
      <div className="two-factor-auth-image">
        <BlueCheckmark />
      </div>
    )}
    <h3 className="two-factor-auth-header">{formatMessage(`TwoFactorAuthentication.Headers.YoureAllSet.${variant}`)}</h3>
    <p className="two-factor-auth-text">{formatMessage(`TwoFactorAuthentication.Texts.Congratulations.${variant}`)}</p>

    <Input
      label={formatMessage('TwoFactorAuthentication.Headers.BackupCode')}
      hasHiddenLabel
      value={backup}
      readOnly
      className="two-factor-auth-input text-center readonly"
    />
    <div className="text-center mx-auto my-4">
      <SecondaryLink onClick={() => copyToClipboard(backup)}>
        {formatMessage('TwoFactorAuthentication.Buttons.Copy')} <CopyIcon className="mb-1" />
      </SecondaryLink>
    </div>

    <div className="two-factor-actions">
      <p className="two-factor-auth-text mb-4">
        <FormattedHTMLMessage id="TwoFactorAuthentication.Texts.PutThisCodeInSafe" />
      </p>
      <Button variant="primary" onClick={primaryAction}>
        {formatMessage('TwoFactorAuthentication.Buttons.Done')}
      </Button>
    </div>
  </div>
);

export default EndStep;
